import { useCountdown, pad } from "@/components/Countdown";

export default function CountdownBanner() {
  const { live, days, hours, minutes, seconds } = useCountdown();

  return (
    <div data-testid="countdown-banner" className="border-b border-[#D4AF37]/25 bg-[#0B0B0F]">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-5 gap-y-1 px-5 sm:px-8 py-3 font-mono text-[10px] sm:text-[11px] tracking-[0.25em]">
        {live ? (
          <span className="uppercase text-[#D4AF37]">The Festival Is Live · All Bets On You ♠</span>
        ) : (
          <>
            <span className="uppercase text-[#B39343]">The Game Begins In</span>
            <span data-testid="countdown-banner-values" className="text-[#E5C97A] tabular-nums">
              {pad(days)}D&nbsp;&middot;&nbsp;{pad(hours)}H&nbsp;&middot;&nbsp;{pad(minutes)}M&nbsp;&middot;&nbsp;{pad(seconds)}S
            </span>
          </>
        )}
      </div>
    </div>
  );
}
